module.exports = __webpack_public_path__ + "static/img/anjunTxt.e6c5f601.jpg";